import { Capacitor, registerPlugin } from '@capacitor/core'

export interface AppUpdateInfo {
  currentVersionCode: number
  currentVersionName: string
  packageName: string
  canInstallPackages: boolean
}

export type AppUpdateStatus =
  | 'installer_opened'
  | 'permission_required'
  | 'invalid_url'
  | 'invalid_sha256'
  | 'invalid_apk'
  | 'outdated_version'
  | 'cache_failed'
  | 'update_failed'

export interface AppUpdateResult {
  status: AppUpdateStatus
  error?: string
  versionCode?: number
  versionName?: string
}

interface AppUpdatePlugin {
  getInfo(): Promise<AppUpdateInfo>
  downloadAndInstall(options: {
    url: string
    versionCode: number
    versionName: string
    sha256: string
  }): Promise<AppUpdateResult>
  openInstallSettings(): Promise<void>
}

const AppUpdate = registerPlugin<AppUpdatePlugin>('AppUpdate')

export function isNativeAppUpdate(): boolean {
  return Capacitor.getPlatform() === 'android'
}

export function getAppUpdateInfo(): Promise<AppUpdateInfo> {
  return AppUpdate.getInfo()
}

export function downloadAndInstallAppUpdate(options: {
  url: string
  versionCode: number
  versionName: string
  sha256: string
}): Promise<AppUpdateResult> {
  return AppUpdate.downloadAndInstall(options)
}

export function openAppUpdateInstallSettings(): Promise<void> {
  return AppUpdate.openInstallSettings()
}
